import React from 'react';
import Header from './Header';

export default function NoPolicy() {
  return (
    <>
      <Header />
      <p className="mt-4 p-3 bg-gray-100 rounded">
        Add your billing method now and contact LeggUP to active your Policy.
        Once your policy is activated, the billing method on file will be used for future payments.
      </p>
    </>
  );
}
